import React, { Component } from 'react'
import styles from '../WebsiteControlPanel.module.css'
import screwheadIcon from '../screwhead.svg'
import ModeSelector from './ModeSelector'

class WebsiteControlPanel extends Component {
    constructor(props){
        super(props);
        this.state = {
            coverIsOn: true,
            numScrewsInPlace: 4,
            topLScrew: {isInPlace: true},
            topRScrew: {isInPlace: true},
            bottomLScrew: {isInPlace: true},
            bottomRScrew: {isInPlace: true},
            nickname: ""
        };
    }
    removeScrew(screw){
        if(document.body.classList.contains("screwdriverCursor")){
            screw.isInPlace = false;
            this.setState((prevState) => ({
                numScrewsInPlace: prevState.numScrewsInPlace - 1
            }),() => {if(this.state.numScrewsInPlace===0){this.removeCover()}});
        }
    }
    removeCover(){
        this.setState({
            coverIsOn: false
        });
    }
    handleAdvancedToolsCheckboxChange = (event) => {
        document.getElementById('advancedToolOptions').classList.toggle("hidden",!event.target.checked);
    }
    handleNicknameChange = (event) => {
        this.setState({
            nickname: event.target.value
        },() => {
            this.props.setNickname(this.state.nickname);
        });
    }
    render(){
        return (
            <div id={styles.controlPanelWrapper} className="onlyVisibleOnBigScreens">
                <div id={styles.controlPanelCover} className={this.state.coverIsOn ? "" : "hidden"}>
                    <img alt="screwhead" onClick={() => this.removeScrew(this.state.topLScrew)} id={styles.screwTopL} src={screwheadIcon} className={this.state.topLScrew.isInPlace ? styles.screw : "hidden"} />
                    <img alt="screwhead" onClick={() => this.removeScrew(this.state.topRScrew)} id={styles.screwTopR} src={screwheadIcon} className={this.state.topRScrew.isInPlace ? styles.screw : "hidden"} />
                    <img alt="screwhead" onClick={() => this.removeScrew(this.state.bottomLScrew)} id={styles.screwBottomL} src={screwheadIcon} className={this.state.bottomLScrew.isInPlace ? styles.screw : "hidden"} />
                    <img alt="screwhead" onClick={() => this.removeScrew(this.state.bottomRScrew)} id={styles.screwBottomR} src={screwheadIcon} className={this.state.bottomRScrew.isInPlace ? styles.screw : "hidden"} />
                </div>
                <div id={styles.controlPanel}>
                    <h2 id={styles.controlPanelHeading}>Website Control Panel</h2>
                    <div className={styles.controlPanelOptionsSection}>
                        <input id="advancedToolsCheckbox" type="checkbox" onChange={this.handleAdvancedToolsCheckboxChange}></input>
                        <label htmlFor="advancedToolsCheckbox">Enable advanced tools</label>
                    </div>
                    <div className={styles.controlPanelOptionsSection}>
                        <label id={styles.modeSelectLabel}>Mode:</label>
                        <ModeSelector></ModeSelector>
                    </div>
                    <div className={styles.controlPanelOptionsSection}>
                        <label id={styles.nicknameLabel}>Nickname:</label>
                        <input type="text" value={this.state.nickname} onChange={this.handleNicknameChange}></input>
                    </div>
                </div>
            </div>
        )
    }
}

export default WebsiteControlPanel